import React from 'react';
import '../styles/LoadingMascot.css';

interface LoadingMascotProps {
  size?: number;
  label?: string;
  variant?: 'inline' | 'block';
  className?: string;
}

const LoadingMascot: React.FC<LoadingMascotProps> = ({
  size = 160,
  label = 'a folhear o caderno…',
  variant = 'block',
  className,
}) => (
  <div
    className={`loading-mascot loading-mascot--${variant} ${className || ''}`}
    role="status"
    aria-live="polite"
  >
    <img
      src={`${process.env.PUBLIC_URL}/animation.gif`}
      alt=""
      width={size}
      height={size}
      decoding="async"
      aria-hidden="true"
    />
    {label && <span className="loading-mascot__label">{label}</span>}
  </div>
);

export default LoadingMascot;
